module.exports = __webpack_public_path__ + "06_short_brown.bf36d3bb.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/boy/layer5/06_short_brown.png
// module id = 9A6R
// module chunks = 0